import { render, staticRenderFns } from "./PasajeCreate.vue?vue&type=template&id=148f6da4&scoped=true"
import script from "./PasajeCreate.vue?vue&type=script&lang=js"
export * from "./PasajeCreate.vue?vue&type=script&lang=js"
import style0 from "./PasajeCreate.vue?vue&type=style&index=0&id=148f6da4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148f6da4",
  null
  
)

export default component.exports